import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'mom-form-field-textarea',
  templateUrl: './form-field-textarea.component.html',
  styleUrls: ['./form-field-textarea.component.scss']
})
export class FormFieldTextareaComponent {
  @Input() autoGrow = true;
  @Input() formCtrl: UntypedFormControl;
  @Input() helpText: string;
  @Input() id: string;
  @Input() label: string;
  @Input() labelPosition: 'fixed' | 'floating' | 'stacked' = 'floating';
  @Input() placeholder: string;
  @Input() required: boolean;
  @Input() rows = 2;

  @Output() blur = new EventEmitter<void>();

  @Output() keydownEnter = new EventEmitter<Event>();
  @Output() keyupEnter = new EventEmitter<Event>();
}
